import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    editIconContainer: {
        justifyContent: "center",
        position: "absolute",
        alignItems: "center",
        height: 30,
        bottom: 0,
        right: 0,
        width: 30
    },
    imagePickerContainer: {
        alignItems: "center"
    },
    buttonsContainer: {
        flexDirection: "row"
    },
    imagePickerTouchable: {
        position: "relative"
    },
    unselectableText: {
        userSelect: "none"
    },
    container: {
        maxHeight: "80%",
        maxWidth: "90%",
        zIndex: 999999,
        width: 450
    },
    formContainer: {
    },
    profileImage: {
        height: 100,
        width: 100
    },
    buttonWrapper: {
        flex: 1
    },
    scroll: {
    }
});

export default stylesheet;
